// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios';
//自动扫描路由下的index.js配置
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Router from "vue-router";
import VueAnimateNumber from 'vue-animate-number'
import  './assets/font/font.css'
import scroll from 'vue-seamless-scroll'
import '../node_modules/echarts/map/js/world.js'

Vue.config.productionTip = false
//显示声明使用Router
Vue.use(Router)
Vue.use(ElementUI)
Vue.use(VueAnimateNumber)
Vue.use(scroll)

Vue.prototype.$axios = axios;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  //配置路由
  router,
  //配置ElementUI
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js